import { SearchOutlined } from '@ant-design/icons';
import { Button, Input, Space } from 'antd';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const DropdownFilterSearch = ({
  searchInput,
  dataIndex,
  selectedKeys,
  setSelectedKeys,
  confirm: search,
  clearFilters
}) => {
  const { t: translate } = useTranslation();
  const handleSearch = () => {
    search();
  };

  const handleReset = () => {
    clearFilters();
  };

  return (
    <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
      <Input
        ref={searchInput}
        placeholder={`${translate('dashboardStaff.Search')} ${dataIndex}`}
        value={selectedKeys[0]}
        onChange={(e) =>
          setSelectedKeys(e.target.value ? [e.target.value.toUpperCase()] : [])
        }
        onPressEnter={handleSearch}
        style={{ marginBottom: 8, display: 'block' }}
      />
      <Space>
        <Button
          type="primary"
          onClick={handleSearch}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90 }}>
          {translate('dashboardStaff.Search')}
        </Button>
        <Button
          onClick={() => clearFilters && handleReset()}
          size="small"
          style={{ width: 90 }}>
          {translate('dashboardStaff.Reset')}
        </Button>
      </Space>
    </div>
  );
};

/**
 * Component definition of proptypes.
 */
DropdownFilterSearch.propTypes = {
  searchInput: PropTypes.any,
  dataIndex: PropTypes.any,
  selectedKeys: PropTypes.any,
  setSelectedKeys: PropTypes.func,
  confirm: PropTypes.func,
  clearFilters: PropTypes.func,
  onClose: PropTypes.func
};

export default DropdownFilterSearch;
